// removed by extract-text-webpack-plugin
module.exports = {"tabHead":"SpecimenSample__tabHead__1FrlL","tabPane":"SpecimenSample__tabPane__gbJ3L","tabPaneStatus":"SpecimenSample__tabPaneStatus__3kF7f","tabForms":"SpecimenSample__tabForms__3YSiM","wrapper":"SpecimenSample__wrapper__3KmC3","submitResult":"SpecimenSample__submitResult__1JrEj","actionWrapper":"SpecimenSample__actionWrapper__24sew","wrapper2faOptions":"SpecimenSample__wrapper2faOptions__2mH5_"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PatientProfile/SpecimenSample/SpecimenSample.css
// module id = 512
// module chunks = 0